import React from "react";
import { Flip, toast } from "react-toastify";

const RenderToast = ({
  type = "error",
  message = "Internal Server Error",
  ...props
}) => {
  let toastId =
    typeof window !== "undefined" &&
    localStorage.getItem("RT_ERROR_IDENTIFIER");
  let toastDetailObject = {
    position: "top-right",
    autoClose: 6000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    transition: Flip,
    ...props,
  };

  // Render message with support for new lines
  const formatMessage = (msg) => {
    if (typeof msg === "string") {
      const lines = msg.split("\n");
      return lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />} {/* Add <br /> except for the last line */}
        </React.Fragment>
      ));
    }
    return msg; // If message is already JSX or non-string
  };

  const HandleSetErrorOnLocalStorage = () => {
    typeof window !== "undefined" &&
      localStorage.setItem("RT_ERROR_IDENTIFIER", "Error Render");
    return toast[type](<div>{formatMessage(message)}</div>, {
      ...toastDetailObject,
      toastId: "Error Render",
    });
  };

  return (
    <>
      {toast.isActive(toastId)
        ? toast.update(toastId, {
            ...toastDetailObject,
            render: <div>{formatMessage(message)}</div>,
            type: type,
          })
        : HandleSetErrorOnLocalStorage()}
    </>
  );
};

export default RenderToast;
